import { render, staticRenderFns } from "./add_expert.vue?vue&type=template&id=54644b66&scoped=true&"
import script from "./add_expert.vue?vue&type=script&lang=js&"
export * from "./add_expert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54644b66",
  null
  
)

export default component.exports